import React, { useState, useEffect } from 'react';
import { TableRow, TableCell, Typography, makeStyles, Checkbox } from "@material-ui/core";
import { formatarCodigoLote, formatarDataEHora, formatarTemperatura } from '../../../shared/utils/Formatacao';
import TableCellEllipsis from '../../../shared/components/table/TableCellEllipsis';
import TableCellText from '../../../shared/components/table/TableCellText';
import { MoreHoriz, MoreVert } from '@material-ui/icons';
import {
    codigoLoteEmRascunho,
    codigoMontagemDeLote,
    TIPO_LOTE_KPA_CODIGO,
} from '../../../shared/utils/Constantes';
import MenuLinhaTabela from './MenuLinhaTabela';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { LIGHT_GRAY_COLOR, SECONDARY_COLOR, SHADOW_GRAY_COLOR, SHADOW_PURPLE_COLOR } from '../../../theme';
import ModalImpressao from '../../modalImpressaoEtiquetas/views/ModalImpressao';
import { CheckCircle, Circle, MinusCircle } from 'react-feather';

const LinhaLotes = ({
    lote,
    index,
    handleVisualizarLote,
    handleClickBaixarAssinaturaDigital,
    handleClickBaixarImagemBiopsia,
    handleClickGerarReciboRecolhimento,
    codigoLaboratorio,
    usaApplet,
    portaGti,
    selecionado,
    handleSelecionar
}) => {

    const {
        id,
        codigo,
        tipoLote,
        tipoConservacao,
        quantidadeAmostras,
        temperatura,
        status,
        dataCadastro,
        temperaturaChegada,
        dataRecolhimento,
        possuiImagemBiopsia,
        possuiAssinaturaDigital
    } = lote;

    const classes = useStyles();
    const history = useHistory();
    const [menuAberto, setMenuAberto] = useState(false);
    const [mouseEmMenu, setMouseEmMenu] = useState(false);
    const [mouseEmBotao, setMouseEmBotao] = useState(false);
    const [modalImpressaoAberto, setModalImpressaoAberto] = useState(false);

    const edicaoAtiva = (status?.codigo === codigoLoteEmRascunho || status?.codigo === codigoMontagemDeLote)
    && lote.tipoLote.codigo != TIPO_LOTE_KPA_CODIGO;
    const visualizacaoAtiva = !edicaoAtiva;
    const algumaAcaoAtiva = edicaoAtiva || visualizacaoAtiva;
    const selecaoAtiva = lote.status.codigo !== codigoLoteEmRascunho;

    const toggleMouseEmMenu = (value) => {
        if (menuAberto) {
            setMouseEmMenu(value);
        }
    };

    const toggleMouseEmBotao = (value) => {
        setMouseEmBotao(value);
    };

    const handleClickEdicao = () => {
        history.push({
            pathname: "/dados-lote",
            search: `?idLote=${id}`
        })
    }

    const corCelulasMenu = menuAberto ? SHADOW_PURPLE_COLOR : 'transparent';

    const stiloCelulaMenu = {
        backgroundColor: corCelulasMenu
    };

    const estiloCelulaDataRecolhimento = {
        minWidth: '150px',
        backgroundColor: corCelulasMenu,
        whiteSpace: 'nowrap'
    };

    const estiloCelulaTempChegada = {
        minWidth: '50px',
        backgroundColor: corCelulasMenu,
        whiteSpace: 'nowrap'
    };

    const handleClickImprimir = () => {
        setModalImpressaoAberto(true);
    };

    useEffect(() => {
        if (algumaAcaoAtiva && (mouseEmMenu || mouseEmBotao)) {
            setMenuAberto(true);
        } else {
            setMenuAberto(false);
        }
    }, [mouseEmMenu, mouseEmBotao, algumaAcaoAtiva]);

    return (
        <>
            <ModalImpressao
                codigoLaboratorio={codigoLaboratorio}
                idLote={id}
                usaApplet={usaApplet}
                portaGti={portaGti}
                modalAberto={modalImpressaoAberto}
                setModalAberto={setModalImpressaoAberto}
            />
            <TableRow key={index + codigo} id={codigo}>
                <TableCell className={classes.gridCheckBox} title={selecaoAtiva ? "" : "Lotes em rascunho não podem ser inclusos no manifesto de carga."}>
                    <Checkbox
                        disabled={!selecaoAtiva}
                        className={classes.checkBox}
                        onClick={()=> handleSelecionar(lote)}
                        checked={selecionado}
                        icon={selecaoAtiva ? <Circle size={16} /> : <MinusCircle size={16} />}
                        checkedIcon={<CheckCircle color={SECONDARY_COLOR} size={16} />}
                    />
                </TableCell>
                <TableCellText text={formatarCodigoLote(codigo)} />
                <TableCellEllipsis text={tipoLote?.descricao} width="145px" />
                <TableCellText text={tipoConservacao?.descricao} />
                <TableCellEllipsis text={status?.descricao} width="150px" />
                <TableCell align="left">
                    <Typography>{quantidadeAmostras}</Typography>
                </TableCell>
                <TableCell align="left">
                    <Typography>{formatarTemperatura(temperatura)}</Typography>
                </TableCell>
                <TableCellText text={formatarDataEHora(dataCadastro)} />
                <TableCell
                    onMouseEnter={() => toggleMouseEmMenu(true)}
                    onMouseLeave={() => toggleMouseEmMenu(false)}
                    style={estiloCelulaDataRecolhimento}
                >
                    {menuAberto ?
                        (<MenuLinhaTabela
                            edicaoAtiva={edicaoAtiva}
                            impressaoAtiva={status?.codigo === codigoMontagemDeLote}
                            baixarImagemBiopsiaAtiva={possuiImagemBiopsia}
                            baixarImagemAssinaturaAtiva={possuiAssinaturaDigital}
                            baixarReciboRecolhimento={dataRecolhimento != null}
                            handleClickEdicao={handleClickEdicao}
                            handleClickImprimir={handleClickImprimir}
                            handleClickVisualizacao={() => handleVisualizarLote(lote)}
                            handleClickBaixarAssinaturaDigital={() => handleClickBaixarAssinaturaDigital(lote)}
                            handleClickBaixarImagemBiopsia={() => handleClickBaixarImagemBiopsia(lote)}
                            handleClickGerarReciboRecolhimento={() => handleClickGerarReciboRecolhimento(lote)}
                        />)
                        : (<Typography>{formatarDataEHora(dataRecolhimento)}</Typography>)
                    }
                </TableCell>
                <TableCell
                    align="left"
                    onMouseEnter={() => toggleMouseEmMenu(true)}
                    onMouseLeave={() => toggleMouseEmMenu(false)}
                    style={estiloCelulaTempChegada}
                >
                    {!menuAberto && <Typography>{formatarTemperatura(temperaturaChegada)}</Typography>}
                </TableCell>
                <TableCell
                    style={stiloCelulaMenu}
                    onMouseEnter={() => toggleMouseEmBotao(true)}
                    onMouseLeave={() => toggleMouseEmBotao(false)}
                    onClick={() => toggleMouseEmBotao(!menuAberto)}
                >
                    {menuAberto ? (
                        <MoreVert size={15} style={{ color: "white" }} />
                    ) : (
                        <MoreHoriz size={15} style={
                            algumaAcaoAtiva
                                ? { color: SHADOW_GRAY_COLOR }
                                : { color: LIGHT_GRAY_COLOR }
                        } />
                    )}
                </TableCell>
            </TableRow >
        </>
    );
}

const useStyles = makeStyles((theme) => ({
    gridCheckBox: {
      padding: "0px 0px 0px 0px",
      minWidth: "50px",
      maxWidth: "50px"
    },
    checkBox: {
      padding: "0px 0px 0px 0px"
    },
}))

const mapStateToProps = state => {
    return {
        codigoLaboratorio: state.login.laboratorio.codigo,
        usaApplet: state.login.laboratorio.usaApplet,
        portaGti: state.login.laboratorio.portaGti
    };
};

export default connect(
    mapStateToProps
)(LinhaLotes);